import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CircleText.css';

const CircleText = ({
  className = '',
  children = '',
  circleSize = 16,
  circleColor = 'transparent',
  circleAriaHidden = false,
  bordered = false,
  alignment = 'left',
  ...otherProps
}) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-circle-text',
    {
      'bordered': bordered,
    },
    className,
  );

  return (
    <div
      className={classes}
      {...otherProps}
    >
      {alignment === 'right' && children}
      <svg
        preserveAspectRatio="xMaxYMax"
        viewBox="0 0 16 16"
        style={{ height: circleSize, width: circleSize }}
        aria-hidden={circleAriaHidden}
      >
        <circle r={7} cy={8} cx={8} fill={circleColor} />
      </svg>
      {(alignment === 'left' || !alignment) && children}
    </div>
  );
};



CircleText.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  circleSize: PropTypes.number,
  circleColor: PropTypes.string,
  bordered: PropTypes.bool,
  circleAriaHidden: PropTypes.bool,
  alignment: PropTypes.oneOf(['right', 'left']),
};

export default CircleText;